<template>
    <div class="mainPage">
        <!-- <div class="agentTip" v-if="!isChrome">
            <span>建议使用Chrome浏览器，以获得最佳体验</span>
            <div class="closeTip" @click="isChrome = true">×</div>
        </div> -->
        <div class="header_banner">
            <header>
                <div class="center">
                    <div class="left">
                        <a :href="'https://www.chineseplus.net?lang=' + language" target="_blank">{{
                            $t('message.chineseplus')
                        }}</a>
                        <a :href="'https://mooc.chineseplus.net/dist/#/index?lang=' + language" target="_blank">{{
                            $t('message.mooc') }}</a>
                        <a :href="'https://weike.chineseplus.net?lang=' + language" target="_blank">{{
                            $t('message.micClass')
                        }}</a>
                        <!-- <a href="http://www.chinesetest.cn/ChangeLan.do" target="_blank">{{ $t('message.HSKExam') }}</a>
                        <a :href="'https://case.chineseplus.net/?lang='+language" target="_blank">{{ $t('message.teachingResource') }}</a> -->
                    </div>
                    <div class="right">
                        <img src="../img/2022chinesepluslive/lang_icon.png" alt="">
                        <language class="languageCon" ref="language"></language>
                        <div v-if="!isLogin" class="loginCon">
                            <span @click="toLogin()">{{ $t('message.login') }}</span> /
                            <span @click="toLogin()">{{ $t('message.register') }}</span>
                        </div>
                        <div v-if="isLogin" class="loginCon">
                            <span><span class="username">{{ user.username }}</span><span @click="toLogOut()">{{
                                $t('message.logout') }}</span> </span>
                        </div>
                    </div>
                </div>

            </header>
            <div class="infoCon">
                <!-- <img src="../img/2022chinesepluslive/left.png" alt="" class="banner_left"> -->
                <!-- <img src="../img/2022chinesepluslive/right.png" alt="" class="banner_right"> -->

                <div class="centerBg">
                    <img src="../img/2023chinesepluslive/title.png" alt="" class="left" v-if="language == 'cn'">
                    <img src="../img/2023chinesepluslive/title.png" alt="" class="left" v-if="language == 'en'">
                    <img src="../img/2023chinesepluslive/title.png" alt="" class="left" v-if="language == 'es'">
                    <img src="../img/2023chinesepluslive/title.png" alt="" class="left" v-if="language == 'fr'">
                    <img src="../img/2023chinesepluslive/title.png" alt="" class="left" v-if="language == 'ru'">
                    <!-- <img src="../img/2022chinesepluslive/bg_right.png" alt="" class="right"> -->
                </div>
            </div>
        </div>
        <div class="tabCon">
            <div class="menu" @click="showMemu = !showMemu">
                {{ currentMenu }}
                <span class="caret" :class="{ 'activeCaret': showMemu }"></span>
                <div class="menuList" :class="{ 'menuActive': showMemu }">
                    <span :class="{ 'active': currentMenu == 2023 }" @click="changePage(2023)">2023</span>
                    <span :class="{ 'active': currentMenu == 2022 }"
                        @click="changePage(2022, 'https://z.chineseplus.net/dist/#/pcpage/chineseplus_live2022')">2022</span>
                    <span :class="{ 'active': currentMenu == 2021 }"
                        @click="changePage(2021, 'https://z.chineseplus.net/dist/#/pcpage/chineseplus_classlive')">2021</span>
                    <span :class="{ 'active': currentMenu == 2020 }"
                        @click="changePage(2020, 'https://z.chineseplus.net/cio_classlive.html')">2020</span>
                </div>
            </div>
            <div>

                <div class="tabBtn" :class="{ 'activeTab': activeTab == 0 }" @click="changeTab(0)">
                    <div>{{ $t('message.allCourse') }}</div>
                </div>
								<div class="tabBtn" :class="{ 'activeTab': activeTab == 3 }" @click="changeTab(3)">
                    <div>{{ $t('message.HSK4B') }} </div>
                </div>
                <div class="tabBtn" :class="{ 'activeTab': activeTab == 1 }" @click="changeTab(1)">
                    <div>{{ $t('message.HSK4A') }} </div>
                </div>
                <div class="tabBtn" :class="{ 'activeTab': activeTab == 2 }" @click="changeTab(2)">
                    <div>{{ $t('message.spokenChinese2') }} </div>
                </div>
								

            </div>
        </div>
        <div class="courseListCon">
            <!-- <div class="listClass" v-if="language == 'cn' || language == 'en'" >
                <div class="liveClassBtn" :class="{ 'btnActive_left': courseSwitch == 'live' }" @click="switchCourse('live')">{{ $t('message.liveClass') }}</div>
                <div class="replayClassBtn" :class="{ 'btnActive_right': courseSwitch == 'replay' }" @click="switchCourse('replay')">{{ $t('message.playBack') }}</div>
            </div>
            <div class="listClass listClass2" v-if="language == 'es' || language == 'fr' || language == 'ru'" >
                <div class="liveClassBtn" :class="{ 'btnActive_left': courseSwitch == 'live' }" @click="switchCourse('live')">{{ $t('message.liveClass') }}</div>
                <div class="replayClassBtn" :class="{ 'btnActive_right': courseSwitch == 'replay' }" @click="switchCourse('replay')">{{ $t('message.playBack') }}</div>
            </div> -->
            <ul class="list">
                <li v-for="(item, index) in courseList" :key="item.id"
                    :class="{ 'live': item.customStatus == 1, 'finished': item.customStatus == 2 }"
                    v-show="(activeTab == 0) || (item.category == activeTab && activeTab != 0 )">
                    <div class="timeCon">
                        <span class="time">{{ new Date(+item.start_time).Format('YYYY.MM.DD hh:mm') }} - {{ new
                            Date(+item.end_time).Format('hh:mm') }}</span>
                        <span class="status live" v-if="item.customStatus == 0">
                            {{ $t('message.classnNoBegin') }}
                        </span>
                        <span class="status live" v-if="item.customStatus == 1">
                            {{ $t('message.classLive') }}
                        </span>
                        <span class="status finished" v-if="item.customStatus == 2">
                            {{ $t('message.classFinished') }}
                        </span>
                    </div>
                    <div class="detailBox">
                        <div class="nameCon">
                            <div class="name" v-if="language == 'cn'">
                                <span>
                                    {{ item.name }}
                                </span>
                            </div>
                            <div class="name name_en" v-if="language == 'en'">
                                <span v-if="item.name_en">
                                    {{ item.name_en }}
                                </span>
                                <span v-else>
                                    {{ item.name }}
                                </span>
                            </div>
                            <div class="name name_en" v-if="language == 'es'">
                                <span v-if="item.name_es">
                                    {{ item.name_es }}
                                </span>
                                <span v-else>
                                    {{ item.name }}
                                </span>
                            </div>
                            <div class="name name_en" v-if="language == 'fr'">
                                <span v-if="item.name_fr">
                                    {{ item.name_fr }}
                                </span>
                                <span v-else>
                                    {{ item.name }}
                                </span>
                            </div>
                            <div class="name name_en" v-if="language == 'ru'">
                                <span v-if="item.name_ru">
                                    {{ item.name_ru }}
                                </span>
                                <span v-else>
                                    {{ item.name }}
                                </span>
                            </div>
                        </div>
                        <div class="titleCon">
                            <div class="title">
                                <div class="cn" v-if="language == 'cn'">
                                    {{ item.teacher_name }}
                                </div>
                                <div class="en" v-if="language == 'en'">
                                    <span v-if="item.teacher_name_en">
                                        {{ item.teacher_name_en }}
                                    </span>
                                    <span v-else>
                                        {{ item.teacher_name }}
                                    </span>
                                </div>
                                <div class="en" v-if="language == 'es'">
                                    <span v-if="item.teacher_name_es">
                                        {{ item.teacher_name_es }}
                                    </span>
                                    <span v-else>
                                        {{ item.teacher_name }}
                                    </span>
                                </div>
                                <div class="en" v-if="language == 'fr'">
                                    <span v-if="item.teacher_name_fr">
                                        {{ item.teacher_name_fr }}
                                    </span>
                                    <span v-else>
                                        {{ item.teacher_name }}
                                    </span>
                                </div>
                                <div class="en" v-if="language == 'ru'">
                                    <span v-if="item.teacher_name_ru">
                                        {{ item.teacher_name_ru }}
                                    </span>
                                    <span v-else>
                                        {{ item.teacher_name }}
                                    </span>
                                </div>
                            </div>
                            <div class="liveBtn">
                                <span class="join"
                                    v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == false"
                                    @click="join(item, index, false)">
                                    <span class="En">
                                        {{ $t('message.join') }}
                                    </span>
                                </span>
                                <span class="join replay" v-if="item.status == 3" @click="replay(item.video_url)">
                                    <span class="En">
                                        {{ $t('message.playBack') }}
                                    </span>
                                </span>
                                <span class="isOrder"
                                    v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == true">
                                    {{ $t('message.classnNoBegin') }}
                                </span>
                                <span class="join" v-if="item.status == 1 && item.customStatus == 1"
                                    @click="joinToLive(item, index)">
                                    <span class="En">
                                        {{ $t('message.enter') }}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </li>
                <div class="nomore" >{{ $t('message.noMore') }}</div>
            </ul>
        </div>
        <pcfooter></pcfooter>
        <transition name="fade">
            <div id="videoPlayWrapper" v-if="isPlay">
                <div class="videoContent">
                    <div class="closeVideo" @click="closeVideo()">×</div>
                    <div class="videoContainer"><video :src="currentVideoUrl" id="liveVideo" controls
                            controlsList="nodownload"></video></div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Qs from 'qs'
import pcfooter from './footer'
import language from './common/language'
export default {
    name: 'chinesebridge',
    components: {
        pcfooter,
        language
    },
    metaInfo() {
        return {
            title: '中文联盟在线直播教学-我要学习汉语_汉语文化线上培训平台',
            meta: [
                {
                    name: 'keyword',
                    content: '中文联盟在线直播教学,汉语文化线上培训平台,我要学习汉语'
                },
                {
                    name: 'description',
                    content: '中文联盟汉语文化线上培训平台开设在线直播教学,利用碎片化时间,加强汉语言学习,我要学习汉语就来中文联盟!'
                },
            ]
        }
    },
    data: function () {
        return {
            showMemu: false,
            courseSwitch: 'live', //直播or回放课程分类
            currentMenu: 2023,
            isChrome: true,
            isLogin: false,
            isPlay: false,
            currentVideoUrl: '',
            user: {
                username: '',
                email: ''
            },
            lang: 'cn',
            isShowGuide: true,
            subject_info: {},
            courseList: [],
            activeTab: 3,
            subject_id: null,
            beforeTime: 30, // 提前可进入直播间时间
            afterTime: 30 // 延后关闭直播间时间

        }
    },
    computed: {
        language() {
            return this.$i18n.locale
        }
    },
    methods: {
        // 切换年份
        changePage(page, url) {
            // this.currentMenu = page
            if (url) {
                window.open(url)
            }
        },
        // 切换课程分类
        changeTab(tab) {
            this.activeTab = tab
        },
        // 切换直播or回放
        switchCourse(tab) {
            this.courseSwitch = tab
        },

        tolive(url) {
            window.open(url)
        },
        // 登录
        toLogin() {
            window.location.href =
                this.baseUrl +
                "user/api/login?" +
                "callback=" +
                encodeURIComponent(window.location.href);
        },
        // 注册
        toRegister() {
            window.location.href = 'https://passport.chinesecio.com/static/frontend/dist/#/pc/register?callback=' + encodeURIComponent(window.location.href);
        },
        // 检查是否登录 获取用户信息
        customCheckLogin() {
            this.checkLogin().then(res => {
                if (res.data.success) {
                    this.isLogin = true
                    this.user = res.data.data
                } else {
                    this.isLogin = false
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        // 退出登录
        toLogOut() {
            this.$utils.get('/user/api/logout').then(res => {
                if (res.data.success) {
                    this.isLogin = false
                }
            })
        },
        // 获取专题信息
        getSubjectInfo(alias) {
            this.$utils.get('/subject/subject/readbyalias', {
                alias
            }).then(res => {
                if (res.data.success) {
                    this.subject_info = res.data.data
                    this.getCourseInfo(this.subject_info.id)
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        // 通过专题ID信息 获取课程列表
        getCourseInfo(id) {
            this.$utils.get('/subject/lesson/getlist', {
                subject_id: id,
                limit: 200
            }).then(res => { //处理课程列表
                if (res.data.success) {
                    var now = new Date().getTime() //获取当前时间戳
                    var endTime = now - this.afterTime * 60 * 1000 //当前时间的30分钟前
                    var nowBeforeFiveMin = now + this.beforeTime * 60 * 1000 //当前时间的30分钟后
                    res.data.data.list.forEach(e => {
                        e.isOrder = false //预约课程标志
                        e.customStatus = 0 // 0:直播未开始 1:正在直播 2：直播已结束 (直播时间段前后30分钟内都能进入直播室)
                        if (nowBeforeFiveMin > e.start_time) { // 直播开始时间的前30分钟内 可以进入直播
                            e.customStatus = 1
                        }
                        if (endTime > e.end_time) { // 直播结束时间的30分钟后之后 表示直播已经结束
                            e.customStatus = 2
                        }
                    })
                    this.courseList = res.data.data.list
                    this.categoryName() //分类课程，将同一系列的课程提出到一个列表中，
                    this.classifyCourse()// 将课程分类，根据时间判断直播or回放，
                    console.log(this.courseList) //所有课程
                    this.checkOrdeList() //直播间ID列表
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        categoryName() {
            this.courseList.forEach(e => {
                if (e.name.indexOf('HSK标准会话教程（4上）') > -1) {
                    e.category = 1
                } else if (e.name.indexOf('《汉语口语速成》提高篇') > -1) {
                    e.category = 2
                } else if (e.name.indexOf('HSK标准会话教程（4下）') > -1) {
                    e.category = 3
                }
            })
        },
        // classifyCourse() {
        //     this.courseList.forEach(e => {
        //         if(e.name.indexOf('HSK标准会话教程（4上）') > -1) { //直播课程
        //             e.category = 1
        //         }else if(e.name.indexOf('《汉语口语速成》提高篇') > -1) { //回放课程
        //             e.category = 2
        //         }
        //     })
        // },
        // 检查可预约直播间 （有room_id的课程）
        checkOrdeList() {
            const orderRoomId = []
            this.courseList.forEach(e => {
                if (orderRoomId.indexOf(e.room_id) == -1 && e.room_id != 0) {
                    orderRoomId.push(e.room_id)
                }
            })
            this.checkRoomsIsOrder(orderRoomId)
        },
        // 检查用户直播间状态 （用户预约过的课程）
        checkRoomsIsOrder(arr) {
            const data = Qs.stringify({
                rooms: arr.toString(),
                user: this.user.email
            })
            this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/get_user_rooms' + "?time=" + new Date().valueOf(), data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                if (res.data.code == 0) {
                    this.courseList.forEach((e, index) => {
                        if (res.data.data.hasOwnProperty(e.room_id)) { //遍历课程，判断用户直播间状态信息中是否有 对应的课程room_id，如果有表示预约过这门课程，
                            this.courseList[index].isOrder = true //修改预约标志，表示此用户已经预约过此门课程，
                            this.$set(this.courseList, index, this.courseList[index]) //实时修改课程对应的预约标志
                        }
                    })
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        join(item, index, islive) { //课程未开始- 预约课程
            if (!this.isLogin) {
                this.toLogin()
                return
            }
            const data = Qs.stringify({
                room_id: item.room_id,
                user: this.user.email,
                secret: "03198325b8b61ccc3413cf7e754febea",
                key: "zyz",
                username: this.user.username,
                realname: this.user.username
            })
            this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/add_user' + "?time=" + new Date().valueOf(), data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                if (res.data.code == 0) {
                    this.courseList[index].isOrder = true //课程预约成功 
                    this.$set(this.courseList, index, this.courseList[index])
                    if (islive) {
                        window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
                    }
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        joinToLive(item, index) { //课程正在直播中-进入直播间
            if (!this.isLogin) {
                this.toLogin()
                return
            }
            if (!item.isOrder) {
                this.join(item, index, true) //没有加入课程，先加入课程，
            } else { //已经加入课程的直接进入课程直播间
                window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
            }
        },
        replay(url) {
            this.isPlay = true
            this.currentVideoUrl = url
            setTimeout(function () { // 
                $('#liveVideo').bind('contextmenu', function () { return false; }) //为video添加禁止右键另存为操作 
            }, 50)
        },
        closeVideo() {
            var myvideo = document.getElementById("liveVideo");
            if (!myvideo.paused) { //视频正在播放中时停止播放
                myvideo.pause();
            }
            this.isPlay = false
        },
        checkChrome() {
            var isChrome = window.navigator.userAgent.indexOf("Chrome") > -1;
            if (!isChrome) {
                this.isChrome = false
            }
        }
    },
    mounted() {
        // this.subject_id = this.$route.query.id

        this.customCheckLogin()
        this.getSubjectInfo('chineseplus_2023live')
        this.checkChrome()
        let activeTab = this.$route.query.tab
        if (activeTab) {
            this.activeTab = activeTab
        }
        let lang = this.$route.query.lang
        if (lang) {
            this.lang = lang
            this.$refs.language.changeLanguage(this.lang)
        }

    }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">
.mainPage {
    width: 100%;
    text-align: center;
    position: relative;
    min-height: 100%;
    background-color: #ebf0f9;

    .agentTip {
        width: 100%;
        height: 70px;
        line-height: 70px;
        background-color: #ffe6a1;
        text-align: center;
        position: absolute;
        z-index: 5;
        color: #c40000;
    }

    .agentTip .closeTip {
        position: absolute;
        right: 24px;
        top: 0px;
        font-size: 30px;
        color: #282828;
        cursor: pointer;
    }

    .header_banner {
        position: relative;
        // background-image: linear-gradient(0deg, 
        // #ffffff 0%, 
        // #cad9ff 100%), 
        // linear-gradient(
        //     #6187d6, 
        //     #6187d6);
        // background-blend-mode: normal, 
        // normal;
        background-image: url(../img/2023chinesepluslive/bg.png);
        height: 260px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;

        header {
            position: absolute;
            height: 50px;
            line-height: 50px;
            z-index: 2;
            border-bottom: 1px solid rgba(#fff, 0.3);
            top: 0;
            width: 100%;
            margin: auto;
            color: #fff;

            .center {
                color: #8590cc;
                width: 1200px;
                margin: auto;

                a {
                    color: #8590cc;
                    margin-right: 15px;
                    // opacity: 0.8;
                }
            }

            .left {
                float: left;
            }

            .right {
                line-height: 50px;
                float: right;

                img {
                    vertical-align: text-top;
                    margin-right: 15px;
                }

                .loginCon {
                    display: inline-block;
                    margin-left: 30px;

                    span {
                        cursor: pointer;
                    }

                    .username {
                        margin-right: 12px;
                    }
                }
            }
        }
    }

    .loginWrapper {
        font-size: 16px;
        color: #fff;
        display: inline-block;
        margin-left: 20px;
        cursor: pointer;

        span {
            margin: 0 5px;
            cursor: pointer;
        }
    }

    .loginWrapper {
        font-size: 16px;
        color: #fff;
        display: inline-block;
        margin-left: 20px;
        cursor: pointer;

        span {
            margin: 0 5px;
            cursor: pointer;
        }
    }

    .infoCon {

        .centerBg {
            width: 1200px;
            margin: auto;
            position: absolute;
            top: 62px;
            left: 0;
            right: 0;

            .left {
                float: left;
                margin-top: 10px;
            }

            .right {
                float: right;
            }
        }

        .banner_right {
            position: absolute;
            right: 0;
            top: 0;
        }

        .banner_left {
            position: absolute;
            left: 0;
            bottom: 0;
        }

        .banner {
            width: 100%;
            height: 350px;
        }

        .info {
            position: absolute;
            top: 0;
            bottom: 0;
            width: 1200px;
            left: 0;
            right: 0;
            margin: auto;
            text-align: left;

            .infoName {
                width: 75%;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);

                .name {
                    font-size: 38px;
                    color: #fff;
                    font-weight: bold;
                    line-height: 1.2;
                }

                .name_en {
                    font-size: 30px;
                    color: #fff;
                    font-family: Georgia;
                    margin-top: 20px;
                }
            }
        }
    }

    .tabCon {
        display: inline-block;
        vertical-align: top;
        width: 300px;
        margin-top: 45px;
        // margin-left: 200px;
        background-color: #fff;
        box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.1);
        border-radius: 10px;

        .menu {
            width: 100%;
            position: relative;
            display: inline-block;
            text-align: left;
            color: #fff;
            // font-weight: bold;
            font-size: 22px;
            height: 50px;
            line-height: 50px;
            padding-left: 30px;
            box-sizing: border-box;
            border-radius: 10px 10px 0 0;
            background-color: #95b2fd;
            cursor: pointer;

            .caret {
                float: right;
                display: inline-block;
                width: 0;
                height: 0;
                margin-top: 25px;
                margin-right: 15px;
                vertical-align: middle;
                border-top: 6px dashed;
                border-top: 6px solid\9;
                border-right: 6px solid transparent;
                border-left: 6px solid transparent;
                opacity: .9;
            }

            .activeCaret {
                border-top: none;
                border-bottom: 6px dashed;
            }

            .menuList {
                position: absolute;
                z-index: 2;
                width: 100%;
                top: 50px;
                font-size: 18px;

                left: 0;
                color: #282828;
                font-weight: normal;
                background-color: #fff;
                border-radius: 0 0 4px 4px;
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
                transition: all linear 0.2s;
                height: 0;
                overflow: hidden;

                span {
                    display: block;
                    height: 50px;
                    padding-left: 30px;
                    box-sizing: border-box;
                    border-bottom: 1px solid #ccc;
                }

                .active {
                    color: #6173bf;
                }
            }

            .menuActive {
                height: 200px;
            }
        }

        >div {
            // width: 1200px;
            // width: 100%;
            // margin: auto;
            // height: 100%;

        }

        .tabBtn {
            text-align: left;
            padding: 15px 15px;
            cursor: pointer;
            font-size: 18px;
            box-sizing: border-box;
        }

        .activeTab {
            background-color: rgba(#95b2fd, 0.3);
            color: #6173bf;
            font-weight: bolder;
        }
    }

    .courseListCon {
        position: relative;
        z-index: 2;
        display: inline-block;
        vertical-align: top;
        width: 870px;
        min-height: 400px;
        margin: 45px auto 30px;
        background-color: #fff;
        margin-left: 25px;
        box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.1);
        border-radius: 10px;

        .listClass {
            display: flex;
            justify-content: space-around;
            align-items: center;
            width: 300px;
            margin: auto;
            margin-top: 15px;
            margin-bottom: 60px;
            background: #fff;
            border: 1px solid #d6d6d6;
            border-radius: 10px;
            box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.1);
            cursor: pointer;

            .liveClassBtn {
                height: 40px;
                width: 50%;
                font-size: 18px;
                line-height: 40px;
                border-right: 1px solid #d6d6d6;

            }

            .replayClassBtn {
                height: 40px;
                width: 50%;
                font-size: 18px;
                line-height: 40px;
            }

            .btnActive_left {
                background-color: #4a88da;
                border-radius: 10px 0 0 10px;
                color: #fff;
            }

            .btnActive_right {
                background-color: #4a88da;
                border-radius: 0px 10px 10px 0;
                color: #fff;
            }

        }
        .listClass2{
            width: 500px;
        }

        // .liveClass {
        //     padding-top: 60px;
        //     margin-bottom: 58px;
        // }
        .list {
            position: relative;
            padding: 0 18px;
            text-align: left;
            margin-top: 50px;
            margin-bottom: 100px;

            li {
                margin-left: 60px;
                margin-bottom: 40px;
                position: relative;

                &:before {
                    position: absolute;
                    left: -65px;
                    top: -15px;
                    content: '';
                    width: 59px;
                    height: 200px;
                    background-image: url(../img/2023chinesepluslive/icon3.png);
                }

                .timeCon {
                    .time {
                        font-size: 24px;
                        color: #474f52;
                        font-family: "DIN-Medium";
                    }

                    .live {
                        font-size: 12px;
                        color: #ffffff;
                        background-color: #3caf4f;
                        margin-left: 30px;
                        vertical-align: text-top;
                        padding: 5px 9px 5px 6px;
                        border-radius: 10px 0 10px 0;
                    }

                    .finished {
                        font-size: 12px;
                        color: #ffffff;
                        background-color: #93a4aa;
                        margin-left: 30px;
                        vertical-align: text-top;
                        padding: 5px 9px 5px 6px;
                        border-radius: 10px 0 10px 0;
                    }
                }

                .detailBox {
                    width: 755px;
                    height: 120px;
                    margin-top: 25px;
                    border: 1px solid #d6d6d6;
                    border-radius: 10px;
                    box-shadow: 0px 2px 40px 0px rgba(0, 0, 0, 0.1);

                    .nameCon {
                        margin-top: 25px;
                        margin-bottom: 20px;

                        .name {
                            font-size: 20px;
                            font-weight: bolder;
                            line-height: 1.2;
                            color: #364347d6;
                            width: 585px;
                            margin-left: 20px;
                        }

                        .name_en {
                            font-size: 20px;
                            line-height: 1.2;
                            color: #364347d6;
                            margin-bottom: 8px;
                            font-family: 'Georgia';
                            width: 585px;
                        }
                    }

                    .titleCon {
                        .title {
                            color: #8da6ac;
                            display: inline-block;

                            .en {
                                font-size: 20px;
                                font-family: 'Georgia';
                                margin-bottom: 2px;
                                width: 585;
                                line-height: 1.2;
                                margin-left: 20px;
                            }

                            .cn {
                                font-size: 14px;
                                width: 585;
                                line-height: 1.2;
                                margin-left: 20px;
                            }
                        }

                        .liveBtn {
                            float: right;
                            display: inline-block;
                            font-family: 'Georgia';
                            color: #282828;
                            margin-top: -27px;
                            margin-right: 30px;

                            .join {
                                position: relative;
                                display: inline-block;
                                height: 36px;
                                // width: 130px;
                                line-height: 1.2;
                                border-radius: 25px;
                                background-color: #fff;
                                color: #fa6c51;
                                border: 1px solid #fa6c51;
                                // padding: 15px 31px;
                                box-sizing: border-box;
                                cursor: pointer;

                                &:before {
                                    position: absolute;
                                    content: '';
                                    left: 25px;
                                    top: 11px;
                                    border-top: 6px solid transparent;
                                    border-bottom: 6px solid transparent;
                                    border-left: 10px solid #fa6c51;
                                }

                                .En {
                                    font-size: 16px;
                                    vertical-align: top;
                                    margin-left: 50px;
                                    margin-right: 20px;
                                    line-height: 36px;
                                }

                                .Cn {
                                    font-size: 16px;
                                    vertical-align: top;
                                    margin-left: 50px;
                                    line-height: 36px;
                                }
                            }

                            .replay {
                                color: #8da6ac;
                                border: 1px solid #8da6ac;

                                &:before {
                                    position: absolute;
                                    content: '';
                                    left: 25px;
                                    top: 11px;
                                    border-top: 6px solid transparent;
                                    border-bottom: 6px solid transparent;
                                    border-left: 10px solid #8da6ac;
                                }

                                .En {
                                    margin-left: 50px;
                                    margin-right: 20px;
                                }
                            }

                            .isOrder {
                                color: #999;
                            }
                        }
                    }
                }


            }

            .live:before {
                background-image: url(../img/2023chinesepluslive/icon2.png);
            }

            .finished:before {
                background-image: url(../img/2023chinesepluslive/icon1.png);
            }

            .nomore {
                position: absolute;
                font-size: 20px;
                bottom: -60px;
                left: 120px;
                color: #8da6ac;

            }
        }
    }

    .joinUs {
        position: fixed;
        right: 70px;
        bottom: -3px;
        z-index: 100;

    }

    .guideModel {
        position: fixed;
        right: 0;
        bottom: 40px;
        z-index: 5;
        cursor: pointer;

        .close {
            font-size: 28px;
            position: absolute;
            top: 15px;
            right: 15px;
            color: #fff;
            cursor: pointer;
        }
    }

    #videoPlayWrapper {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 999;
    }

    #videoPlayWrapper .closeVideo {
        position: absolute;
        right: 20px;
        top: 10px;
        font-size: 50px;
        color: #fff;
        cursor: pointer;
    }

    .videoContent {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .videoContainer {
        text-align: center;
        width: 100%;
    }

    .videoContainer video {
        width: 62%;
    }

    video::-internal-media-controls-download-button {
        display: none;
    }

    video::-webkit-media-controls-enclosure {
        overflow: hidden;
    }

    video::-webkit-media-controls-panel {
        width: calc(100% + 30px);
    }
}

// 110%
@media only screen and (min-width: 1541px) and (max-width: 1746px) {


    .mainPage .joinUs {
        right: 30px;
    }
}

// 125%
@media only screen and  (max-width: 1540px) {

    .mainPage .joinUs {
        display: none;
    }

}

</style>
